module.exports = __webpack_public_path__ + "static/media/ta-07.98049862.png";